import styled from "styled-components";

export const WrapperStyled = styled.div`
  min-height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
